module.exports = __webpack_public_path__ + "img/c08_unittechspearmanchampion_Normal_ua.99aedd68.webp";